import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material"
import { useFormik } from "formik"
import { dialogModes } from "../../../constants"
import * as yup from "yup"

const getTitle = dialogMode => {
    switch (dialogMode) {
        case dialogModes.CREATE:
            return "Создание занятия"
        case dialogModes.UPDATE:
            return "Редактирование занятия"
        default: return "Просмотр занятия"
    }
}

const LessonForm = ({
    open, onClose, dialogMode, data, onSave,
    subjectOptions, subjectLookups,
    groupOptions, groupLookups,
    studioOptions, studioLookups,
}) => {

    const { values, errors, touched, setFieldValue, handleChange, handleSubmit } = useFormik({
        initialValues: data,
        enableReinitialize: true,
        onSubmit: onSave,
        validationSchema: yup.object({
            date: yup.date().required(),
            duration: yup.number().required().min(0),
            subject: yup.number().required(),
            group: yup.number().required(),
            studio: yup.number().required(),
        })
    })

    if (!values) return null

    return <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">

        <DialogTitle>{getTitle(dialogMode)}</DialogTitle>

        <DialogContent>

            <TextField
                id="date"
                name="date"
                type="date"
                label="Дата проведения"
                value={values.date?.split("T")?.[0]}
                onChange={e => {
                    const prevTime = values.date.split("T")[1]
                    setFieldValue("date", `${e.target.value}T${prevTime}`)
                }}
                error={touched.date && Boolean(errors.date)}
                fullWidth
                slotProps={{ inputLabel: { shrink: true } }}
            />

            <TextField
                id="date-time"
                type="time"
                label="Время начала"
                value={values.date?.split("T")?.[1]?.slice(0, 8)}
                onChange={e => {
                    const prevDate = values.date.split("T")[0]
                    setFieldValue("date", `${prevDate}T${e.target.value}`)
                }}
                error={touched.date && Boolean(errors.date)}
                fullWidth
                slotProps={{ inputLabel: { shrink: true } }}
            />

            <TextField
                id="duration"
                name="duration"
                type="number"
                label="Длительность занятия (в минутах)"
                value={values.duration}
                onChange={handleChange}
                error={touched.duration && Boolean(errors.duration)}
                fullWidth
                slotProps={{ inputLabel: { shrink: true } }}
            />

            <Autocomplete
                value={values.subject}
                options={subjectOptions}
                getOptionLabel={option => subjectLookups[option]?.name ?? ""}
                onChange={(_, value) => setFieldValue("subject", value)}
                renderInput={props => <TextField
                    id="subject"
                    label="Предмет"
                    error={touched.subject && Boolean(errors.subject)}
                    {...props}
                />}
            />

            <Autocomplete
                value={values.group}
                options={groupOptions}
                getOptionLabel={option => groupLookups[option]?.name ?? ""}
                onChange={(_, value) => setFieldValue("group", value)}
                renderInput={props => <TextField
                    id="group"
                    label="Группа"
                    error={touched.group && Boolean(errors.group)}
                    {...props}
                />}
            />

            <Autocomplete
                value={values.studio}
                options={studioOptions}
                getOptionLabel={option => studioLookups[option]?.name ?? ""}
                onChange={(_, value) => setFieldValue("studio", value)}
                renderInput={props => <TextField
                    id="studio"
                    label="Студия"
                    error={touched.studio && Boolean(errors.studio)}
                    {...props}
                />}
            />

        </DialogContent>
        <DialogActions>
            <Button onClick={handleSubmit}>
                Сохранить
            </Button>
            <Button onClick={onClose} color="error">
                Закрыть
            </Button>
        </DialogActions>
    </Dialog>
}

export default LessonForm